export const Constants = {
    production: false,
    API_ROOT: 'http://35.156.190.51:8889/rest/api/auth',
    API_ROOT2: 'http://dqrx-test.draglet.com/en/',
    API_SECRET: 'XBf3hC+XRSG+5k/qTMBnl63+jRwRsUbamGgRO7VtEkrzG8BtsRZM87KKQ6p+Bnw93NbdHNUlRZ2a6gFf41eEOZP0oLyvPEXnrxfUxGakbBmjsyHfBVxPibc55yDNcZi6',
    KEY: '058bd897d71d45cea9ea1dca4870cda8',
    LOADER_ROOTPATH: 'http://chart.azon5.com/assets',
    GUI_ROOTPATH: 'http://chart.azon5.com/assets',
    LOADER_FILEPATH: 'http://chart.azon5.com/assets/ChartUI/init/prochart.loader.min.js',
};



// WEBPACK FOOTER //
// ./src/app/common/Constants.ts